import React from 'react'
import PropTypes from 'prop-types'

import styles from './AlternativeList.module.css'

const AlternativeList = ({ alternatives }) => {
  return (
    <div className={styles.alternative}>
      {alternatives.map(alternative => (
        <div className={styles.sequence}>
          <span className={`${styles.letter} ${styles.backgroundLetter}`}>
            {alternative.sequence}
          </span>
          <span
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: alternative.text }}
          ></span>
        </div>
      ))}
    </div>
  )
}

AlternativeList.propTypes = {
  alternatives: PropTypes.array.isRequired,
}

export default AlternativeList
